/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  var currentURL = window.location.href;
  var alertMessage = "Farbauswahl gespeichert";
  if (currentURL.includes("vantale.de/en")) {
    alertMessage = "Color selection saved"
  }

  window.addEventListener("Angle3DAddToCart", function (event) {
    console.log("Angle3DAddToCart" + JSON.stringify(event.detail));
    alert(alertMessage)
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  // Define the function to dispatch the event
  
  function dispatchCartOpenEvent() {
    var event2 = new Event('theme:cart:add')
    var event = new Event('theme:cart:open');
    
    document.dispatchEvent(event);
    document.dispatchEvent(event2);
    console.log('Opening the cart drawer!');
    // Add your logic to open the cart drawer, if needed
  }
  
  // Use setTimeout to delay the dispatch of the event
  setTimeout(dispatchCartOpenEvent, 2000); // 2000 milliseconds = 2 seconds


  document.addEventListener('theme:cart:add', function() {
    console.log('Item added to the cart!');
    // Add your logic to update the cart, if needed
  });
})();
